/// <reference path="../../include.ts" />
namespace gpx_visualizer_phase2 {

	import View = alm.view.View;
	import IButton = alm.view.IButton;
	import ButtonBehavior = alm.view.ButtonBehavior;

	export class SpeedButton extends View<JQuery> implements IButton {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(view:JQuery) {
			super(view);

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			const view = this.getView();

			this.stateCount = Config.progressDurations.length;
			this.stateIcons = [];
			for (let i = 0; i < this.stateCount; ++i) {
				const icon = jQuery('<div class="icon state-' + i + '">');
				icon.css({
					display: 'none',
					backgroundImage: 'url(../image/progress-speed-button-' + i + '.svg)'
				});
				view.append(icon);
				this.stateIcons.push(icon);
			}
			this.newState = -1;
			this.oldState = -1;

			this.behavior = new ButtonBehavior(this, view.get(0));

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'block');
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'none');
			});
		}





		public implButtonOver(useTransition:boolean):void {
		}

		public implButtonOut(useTransition:boolean):void {
		}

		public implButtonDown(useTransition:boolean):void {
			trace('[SpeedButton] down');
			AudioPlayer.getInstance().getClip(AudioId.lo).play();

			let requiredState = this.newState + 1;
			if (requiredState >= this.stateCount) requiredState = 0;
			trace('[SpeedButton] requiredState :', requiredState);
			this.dispatchEvent(new ControllerSpeedEvent(ControllerSpeedEvent.CHANGE, this, requiredState));
		}

		public implButtonUp(useTransition:boolean):void {
		}

		public implButtonClick(useTransition:boolean):void {
		}

		public implButtonChangeEnabled(isEnabled:boolean, useTransition:boolean):void {
		}





		public setState(state:number):void {
			if (state < 0 || state >= this.stateCount) state = -1;
			if (state == this.newState) return;
			this.oldState = this.newState;
			this.newState = state;

			trace('[SpeedButton] setState :', this.newState);

			if (this.oldState != -1) {
				this.stateIcons[this.oldState].css('display', 'none');
			}
			if (this.newState != -1) {
				this.stateIcons[this.newState].css('display', 'block');
			}
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private behavior:ButtonBehavior;

		private stateIcons:JQuery[];
		private stateCount:number;
		private newState:number;
		private oldState:number;
	}
}
